<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import { mapGetters,mapActions,mapState } from "vuex"
    import axios from 'axios';
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    import DataTable from "@/components/DataTable.vue";

    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Payments Report",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        ModelListSelect,
        DataTable,
      },
      data() {
        return {
          total_amount: 0,
          total_paid: 0,
          filterPayments:{
            datefrom: moment(new Date()).format("YYYY-MM-DD"),
            dateto: moment(new Date()).format("YYYY-MM-DD"),
            customer: '',
          },
          currentdate: moment(new Date()).format("YYYY-MM-DD"),
          title: "Payments Report",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Payments Report",
              active: true,
            },
          ],
          totalRows: 1,
    
          pageOptions: [10, 25, 50, 100, 200, 1000],
          IsSalePaymentsServerPaginated: true,
          serverPerPage:50,
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "customer",
              sortable: true,
              label: 'CUSTOMER',
            },
            {
              key: "amount",
              sortable: true,
              label: 'AMOUNT',
            },
            {
              key: "date",
              sortable: true,
              label: 'DATE',
            },
            {
              key: "mode",
              sortable: true,
              label: 'PAYMENT MODE',
            },
            {
              key: "receipt",
              sortable: true,
              label: "RECEIPT_NO",
            },
            {
              key: "recordedby",
              sortable: true,
              label: "RECEIVED_BY",
            },
            {
              key: "recordedon",
              sortable: true,
              label: "RECORDED_ON",
            }
          ],
        };
      },

    computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
        ...mapGetters("sales", ["filterStatus","SalePayments","SalePaymentsPagination", "SalePaymentsPaginated","IsSalePaymentsServerPaginated"]),
        ...mapGetters("customers", ["Customers"]),
    
       rows() {
        return this.IsSalePaymentsServerPaginated
        ? this.SalePaymentsPagination?.total
        : this.SalePayments
        ? this.SalePayments.length
        : 0;
      },

     perPage: {
      get() {
        if (this.IsSalePaymentsServerPaginated) {
          return (
            this.SalePaymentsPagination.per_page ||
            this.filterPayments.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsSalePaymentsServerPaginated) {
          this.filterPayments.per_page = value;
          this.filterPayments.page = 1;
          this.FetchPayments(this.filterPayments);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.SalePaymentsPaginated && this.SalePaymentsPagination
          ? this.SalePaymentsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.SalePaymentsPaginated) {
          this.filterPayments.page = value;
          this.handlePageChange(value);
        }
      },
      },
    },
      
      methods: {
        ...mapActions({
          FetchPayments: "sales/fetchPayments",
          FetchCustomers: "customers/fetchCustomers",
    
        }),
    
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        SalesPaymentsData() {
          this.FetchPayments(this.filterPayments);
        },
        
        Excel_export() {
          axios
            .post("export_payments", this.filterPayments,{
              responseType: "arraybuffer",
            })
            .then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "payments_report.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              // this.$toast.add({
              //   severity: "success",
              //   summary: "Successful",
              //   detail: "Sales Report Downloaded successfully",
              //   life: 6000,
              // });
              this.spinner = false;
            })
            .catch(() => {
              // this.spinner = false;
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Something wrong",
              //   detail: "Sales Report Download failed",
              //   life: 6000,
              // });
            });
        },

        handlePageChange(newPage) {
       if (this.IsSalePaymentsServerPaginated) {
        this.filterPayments.page = newPage;
        this.FetchPayments(this.filterPayments);
      }
    },
      },

      updated() {
        let total_amount = 0;
          // let total_paid = 0;
          if(this.SalePayments){
            this.SalePayments.forEach((item)=>{
              total_amount = total_amount+parseInt(item.amount);
            });
            this.total_amount = parseInt(total_amount);
          }
      },

      watch: {
        SalePayments(newValue){
          if(newValue == true){
            this.SalesPaymentsData();
          }
        }
      },

      created() {
        this.FetchPayments(this.filterPayments);
        this.FetchCustomers();
        this.SalesPaymentsData();
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center">Payments Report from {{filterPayments.datefrom}} to {{filterPayments.dateto}}</h3>
                  </div>
                </div>            
                <div class="row">
                  <div class="col-md-3 mt-4">
                    <b-button variant="info" @click="Excel_export()"
                      ><i class="fa fa-download"></i>Export</b-button
                    >
                  </div>
                  <div class="col-md-2 form-group mb-2">
                    <label>FROM</label>
                    <input
                      type="date"
                      v-model="filterPayments.datefrom"
                      class="form-control"
                      v-limit-future-date
                    />
                  </div>
                  <div class="col-md-2 form-group">
                    <label>TO</label>
                    <input
                      v-model="filterPayments.dateto"
                      type="date"
                      class="form-control"
                      v-limit-future-date
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>CUSTOMERS</label>
                    
                    <model-list-select
                      :list="
                      Customers
                        ? [{ id: '', name: 'All Customers' }, ...Customers]
                        : []
                      "
                      v-model="filterPayments.customer"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Customer"
                      @input="SalesPaymentsData()"
                    >
                    </model-list-select>
                  </div>
                  <div class="col-md-2 mt-4">
                  <button class="btn btn-primary cursor-pointer" type="button" @click="SalesPaymentsData()">
                    <span class="fa fa-filter cursor-pointer"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                 
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <DataTable
                    :columns="fields"
                    :rows="SalePayments || []"
                    :total-rows="rows"
                    :pagination="SalePaymentsPagination"
                    :server-pagination="IsSalePaymentsServerPaginated"
                    :loading="filterStatus"
                  >
                    <template #cell(index)="{ index }">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                    </template>
                     <template #cell(customer)="{row}">
                      {{ row.customer }}
                    </template>
                     <template #cell(amount)="{row}">
                      {{ row.amount.toLocaleString() }}
                    </template>
                     <template #cell(date)="{row}">
                      {{ row.date }}
                    </template>
                     <template #cell(mode)="{row}">
                      {{ row.mode }}
                    </template>
                     <template #cell(receipt)="{row}">
                      {{ row.receipt }}
                    </template>
                     <template #cell(recordedby)="{row}">
                      {{ row.recordedby }}
                    </template>
                     <template #cell(recordedon)="{row}">
                      {{ row.recordedon }}
                    </template>          
                  </DataTable>
                  <div class="row">
                      <div class="col-md-4"></div>
                      <div class="col-md-4">
                        <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                      </div>
                      <!-- <div class="col-md-4">
                        <h5>Total Paid: <span class="text-danger">{{thousandSeperator(total_paid)}}</span></h5>
                      </div> -->
                    </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    